//import AOS from 'aos';
//import 'aos/dist/aos.css';

export function setCookie(name, value, days) {
    var now = new Date();
    var expTime = now.getTime() + days * 24 * 60 * 60 * 1000;
    var expDate = new Date(expTime);
    document.cookie = name + "=" + value + "; EXPIRES=" + expDate.toGMTString() + "; path=/";
}
export function getCookie(name) {

    var start = document.cookie.indexOf(name + "=");
    if (start == -1)
        return null;
    var len = start + name.length + 1;
    var end = document.cookie.indexOf(";", len);
    if (end == -1)
        end = document.cookie.length;
    return document.cookie.substring(len, end)
}

function fromLatLngToPoint(latLng, map) {
    var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
    var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
    var scale = Math.pow(2, map.getZoom());
    var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
    return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

export function initializeMap(map0) {



    var mapData = JSON.parse(map0.dataset.map.replace(/'/g, '"'));
    if (mapData.length == 0) return;

    var mapOptions = {
        center: new google.maps.LatLng(mapData[0]['map-lat'], mapData[0]['map-lng']),
        zoom: 14,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        /* styles: [
             {
                 stylers: [
                     { saturation: -100 }
                 ]
             }
         ]*/
    };
    var image = "/wp-content/themes/anatour/images/marker.png";
    var map = new google.maps.Map(map0, mapOptions);
    map.myOrigins = map.getCenter();
    var bounds = new google.maps.LatLngBounds();
    const { AdvancedMarkerElement } = google.maps.importLibrary("marker");
    mapData.forEach(function (elem) {



        elem.marker = new google.maps.Marker({
            position: new google.maps.LatLng(elem['map-lat'], elem['map-lng']),
            map: map,
            icon: image,
            //title: elem['map-name'],
            customLabel: elem['map-name'],
        });

        google.maps.event.addListener(elem.marker, 'mouseover', function () {

            var point = fromLatLngToPoint(elem.marker.getPosition(), map);
            $('#marker-tooltip').html(elem.marker.customLabel).css({
                'left': point.x - 16,
                'top': point.y - 10
            }).addClass('show');
        });
        google.maps.event.addListener(elem.marker, 'mouseout', function () {
            $('#marker-tooltip').removeClass('show');
        });

        bounds.extend(elem.marker.position);
        if (elem['map-link']) {
            google.maps.event.addListener(elem.marker, 'click', function () {
                location.assign(elem['map-link']);
            });
        }
        /*
        if (elem['map-name']) {

            elem.window =  new google.maps.InfoWindow({
                content: elem['map-name']
            });

            google.maps.event.addListener(elem.marker, 'click', function () {
                location.assign(elem['map-link']);
            });


        }
        */
    });
    if (mapData.length > 1) {
        map.fitBounds(bounds);
    }

}


/**
* init menu trigger (onClisk)
 */
export const initMenuTrigger = () => {
    const menuTrigger = document.querySelector('.menuTrigger');
    if (menuTrigger) {
        document.querySelectorAll('.menuTrigger').forEach((item) => item.addEventListener('click', e => {
            document.body.classList.toggle('showMenu');
        }));
    }
}

/**
    * init open link in new tab on click for class "newWindow"
    */
export const initOpenInNewTab = () => {
    const newWindow = document.querySelectorAll('.newWindow');
    if (newWindow && newWindow.length > 0) {
        newWindow.forEach(item =>
            item.addEventListener('click', e => {
                e.preventDefault();

                window.open(item.href);
                return false;
            })
        );
    }
}
/**
 * add AOS animation config
 */
/*
export const aosConfig = () => {
    if (typeof AOS !== 'undefined') {
        const anims = document.querySelectorAll('.animUp');
        if (anims.length > 0) {
            [...anims].forEach((anim) => anim.dataset.aos = 'myUp');
        }
        AOS.init({
            duration: 1200,
            // offset: wh * 0.25,
            offset: 100,

            once: true,
            easing: 'ease-out-back',
        });
    }
}
*/
/**
 * add scroll class to body on Scroll
 */
export const addScollClass = (topPosition, className) => {
    if (!!window.IntersectionObserver) {
        let topHeaderObserver = new IntersectionObserver(entries => {
            if (entries[0].intersectionRatio == 0) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        });
        const trigger = document.createElement('div');
        trigger.style.position = 'absolute';
        trigger.style.top = topPosition;
        document.body.appendChild(trigger);
        topHeaderObserver.observe(trigger);
    }
}



/**
 * add class 'gallery-item', fix for fancybox plugin
 * @param {string} cn 
 */
export const galleryAddItemClass = (cn) => {
    const galleryItemFancybox = document.querySelectorAll(cn);
    if (galleryItemFancybox && galleryItemFancybox.length > 0) {
        galleryItemFancybox.forEach(item => {
            item.classList.add('gallery-item');
        });
    }
}

/**
 * add id to gallery holder, fix for fancybox plugin
 * @param {string} gallery 
 */
export const addFancyboxFixForGallery = (gallery) => {
    const galleryFancybox = document.querySelectorAll(gallery);
    if (galleryFancybox && galleryFancybox.length > 0) {
        galleryFancybox.forEach(gallery => {
            const galleryAnchors = gallery.querySelectorAll(':scope a');
            const galeeryId = 'gal' + (Math.floor(Math.random() * 100));
            if (galleryAnchors && galleryAnchors.length > 0) {
                galleryAnchors.forEach(galeeryAnchor => {
                    galeeryAnchor.dataset.fancybox = galeeryId;
                    galeeryAnchor.dataset.caption = galeeryAnchor.nextSibling ? galeeryAnchor.nextSibling.innerHTML : '';
                });
            }
        });
    }
}

/**
 * add close on click for cookies box
 */
const hideCookies = () => {
    document.querySelector('.cookies').classList.add('hide');
}
export const addCloseCookies = () => {
    const cookieBtn = document.querySelector('.cookies__close');
    if (cookieBtn) {
        cookieBtn.addEventListener('click', e => {
            setCookie('hideCookieAlert', 1, 360);
            hideCookies();
            return false;
        });
    }
    if (getCookie('hideCookieAlert')) {
        hideCookies();
    }
}



/**
 * init form script fix
 */
export const initForm = () => {

    var wpcf7Elm = document.querySelectorAll('.wpcf7');
    const inputs = document.querySelectorAll('.wpcf7 input[type=text],.wpcf7 input[type=email],.wpcf7 input[type=tel],.wpcf7 textarea,.wpcf7 select');
    if (inputs) {
        inputs.forEach(item => {
            //item.value = '';
            if (item.nodeName == 'SELECT') item.value = '';
            item.addEventListener('focus', e => e.target.parentNode.parentNode.querySelector(':scope label').classList.add('show'));
            item.addEventListener('focusout', e => {
                if (e.target.value == '' || e.target.value == null) {
                    e.target.parentNode.parentNode.querySelector(':scope label').classList.remove('show')
                }
            });
        });
    }
    const inputsFiles = document.querySelectorAll('.wpcf7 input[type="submit"]');
    if (inputsFiles) {
        inputsFiles.forEach(button => {
            var observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.attributeName === 'disabled' && button.disabled) {
                        button.removeAttribute('disabled');
                    }
                });
            });
            observer.observe(button, { attributes: true });
            button.removeAttribute('disabled');
        });
    }

    if (wpcf7Elm) {
        wpcf7Elm.forEach(wpcf7ElmItem => {
            wpcf7ElmItem.addEventListener('wpcf7invalid', function (event) {
                document.querySelectorAll('.wpcf7-not-valid')
                    .forEach((item) => {
                        if (item.value != "") {
                            item.parentNode.parentNode.querySelector(':scope label').classList.add('show')
                        }
                    });
                jQuery('html,body').animate({ 'scrollTop': ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);
            }, false);
            wpcf7ElmItem.addEventListener('wpcf7mailsent', function (event) {
                document.querySelectorAll('.wpcf7 input').forEach((item) => {
                    if (item.parentNode.parentNode.querySelector(':scope label'))
                        item.parentNode.parentNode.querySelector(':scope label').classList.remove('show');
                });
                jQuery('html,body').animate({ 'scrollTop': ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);
            }, false);
        });
    }
}



/**
 * google map (API) init
 */
export const googleMapInit = () => {
    var map = document.querySelector('.contactMap');
    if (map && typeof google !== 'undefined') {
        google.maps.event.addDomListener(window, 'load', function () {
            initializeMap(map);
        });

    }
}



export const initLoadNews = () => {
    if (!!window.IntersectionObserver) {
        let newsCanBeLoaded = true;
        const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
        let addNewsObserver = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if (newsCanBeLoaded) {
                    loadNews();
                }
            }
        });

        if (newsAjaxTrigger) {
            addNewsObserver.observe(newsAjaxTrigger);
        }

        const loadNews = () => {
            const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
            if (newsAjaxTrigger) {
                newsCanBeLoaded = false;
                newsAjaxTrigger.classList.add('show');
                const formData = new FormData();
                formData.append('action', 'loadmore');
                formData.append('query', ajaxParams.posts);
                formData.append('page', ajaxParams.current_page);
                fetch(ajaxParams.ajaxurl, {
                    method: "post",
                    body: formData
                })
                    .then(res => res.text())
                    .then(res => {
                        if (res) {
                            newsCanBeLoaded = true;
                            ajaxParams.current_page++;
                            newsAjaxTrigger.classList.remove('show');
                            document.querySelector('.newsList').insertAdjacentHTML('beforeend', res);
                        } else {
                            newsCanBeLoaded = false;
                            document.querySelector('.newsAjaxTrigger').remove();
                            addNewsObserver.disconnect();
                        }

                    });
            }

        }
    }
}

const faqServiceTrigger = (trigger, faqHolder) => {
    const tParent = trigger.parentNode;
    const tContent = tParent.querySelector(':scope .gFaq__content');

    [...faqHolder.querySelectorAll(':scope .gFaq__item.active')].forEach((item) => {
        if (!item.isSameNode(tParent)) {
            item.classList.remove('active');
            jQuery(item.querySelector(':scope .gFaq__content')).stop(true, true).slideUp(500)
        }
    });

    if (!tParent.classList.contains('active')) {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideDown(500) : null;
    } else {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideUp(500) : null;
    }
    tParent.classList.toggle('active');

}

export const faqService = () => {
    const faq = document.querySelectorAll('.gFaq');

    if (faq.length > 0) {
        [...faq].forEach((faqItem) => {
            const triggers = faqItem.querySelectorAll(':scope .gFaq__trigger');
            if (triggers.length > 0) {
                [...triggers].forEach((trigger) => {
                    trigger.addEventListener('click', () => faqServiceTrigger(trigger, faqItem));
                });
            }

        });
    }

}

export const initGallerySlider = () => {
    let galleries = document.querySelectorAll('.wp-block-gallery.is-style-gallerySlider');
    if (galleries.length > 0) {
        [...galleries].forEach((gallery) => {
            let galHolder = document.createElement('div');
            let caption = gallery.querySelector(':scope .blocks-gallery-caption');
            galHolder.classList.add('gGallerySliderHolder');
            gallery.parentNode.insertBefore(galHolder, gallery);
            galHolder.appendChild(gallery);
            if (caption) {
                galHolder.appendChild(caption);
            }
            gallery.classList.add('slickSliderUi');
            gallery.classList.add('gGallerySlider');
            typeof jQuery == "function" ? $(gallery).slick({
                infinite: true,
                arrows: true,
                dots: false,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            }) : null;
        });
    }
}

export const initLazyBg = (className = 'lazyBg') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }

}

export const animUp = (className = 'animUp') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }


}

export const initShow = (className = 'animUp', classNameAdd = 'show') => {
    let showList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add(classNameAdd);
                    lazyImageObserver.unobserve(entry.target);
                } /*else {
                    entry.target.classList.remove(classNameAdd);
                }*/
            });
        }, {
            rootMargin: '0px 0px -15% 0px'
        });
        showList.forEach(function (show) {
            lazyImageObserver.observe(show);
        });
    }

}